document.addEventListener("DOMContentLoaded", function () {
  const applianceSelect = document.getElementById("appliance");
  const customWattageGroup = document.getElementById("custom-wattage-group");
  const calculateBtn = document.getElementById("calculate-btn");
  const resultsDiv = document.getElementById("results");

  applianceSelect.addEventListener("change", function () {
    if (this.value === "custom") {
      customWattageGroup.style.display = "block";
    } else {
      customWattageGroup.style.display = "none";
    }
  });

  calculateBtn.addEventListener("click", function () {
    calculateCost();
  });

  // ✅ 修复：绑定到正确的 id "electricity-usage"
  document.getElementById("electricity-usage").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  document.getElementById("price").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  document.getElementById("custom-wattage").addEventListener("keypress", function (e) {
    if (e.key === "Enter") calculateCost();
  });

  function calculateCost() {
    let wattage;
    if (applianceSelect.value === "custom") {
      wattage = parseFloat(document.getElementById("custom-wattage").value);
      if (isNaN(wattage) || wattage <= 0) {
        alert("Please enter a valid wattage");
        return;
      }
    } else {
      wattage = parseFloat(applianceSelect.value);
    }

    // ✅ 修复：从 "electricity-usage" 读取，避免与 lighting 区的 select#usage 冲突
    const usageInput = parseFloat(document.getElementById("electricity-usage").value);
    if (isNaN(usageInput) || usageInput < 0) {
      alert("Please enter a valid usage value");
      return;
    }

    const usageUnit = document.getElementById("usage-unit").value;
    let usageHours;
    if (usageUnit === "minutes") {
      usageHours = usageInput / 60;
    } else {
      usageHours = usageInput;
    }

    const price = parseFloat(document.getElementById("price").value);
    if (isNaN(price) || price < 0) {
      alert("Please enter a valid electricity price");
      return;
    }

    const kWhPerDay = (wattage * usageHours) / 1000;
    const costPerHour = (wattage / 1000) * price;
    const costPerDay = kWhPerDay * price;
    const costPerMonth = costPerDay * 30;
    const costPerYear = costPerDay * 365;

    document.getElementById("cost-hour").textContent = "$" + costPerHour.toFixed(2);
    document.getElementById("cost-day").textContent = "$" + costPerDay.toFixed(2);
    document.getElementById("cost-month").textContent = "$" + costPerMonth.toFixed(2);
    document.getElementById("cost-year").textContent = "$" + costPerYear.toFixed(2);
    document.getElementById("kwh-day").textContent = kWhPerDay.toFixed(2);

    resultsDiv.style.display = "block";
  }
});